import React, { FC, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import Select from 'react-select';
import { fetchData, getTranslatedValue, toasterrormsg, toastsuccessmsg } from '../../../reusable';
import { ToastContainer } from 'react-toastify';
import { AddHotelHeader } from './AddHotelHeader';
import { Tr } from '../../../_metronic/i18n/Tr';
import { useLang } from '../../../_metronic/i18n/Metronici18n';

const AddHotelFacilities: FC = () => {

    const t = Tr()
    const lang = useLang()
    const navigate = useNavigate()
    const categoryId = sessionStorage.getItem('categoryId');
    useEffect(() => {
        if (categoryId != '1') {
            navigate('../dashboard/');
        }
    }, [categoryId])
    const location = useLocation();
    const editHotelId = (location.state as any)?.hotelId || '';
    const [hotelDetails, setHotelDetails] = useState([]);

    var vendorId = "";
    const vendorData = sessionStorage.getItem("vendor");
    if (vendorData) {
        var vendor = JSON.parse(vendorData);
        vendorId = vendor.vendorId;
    } else {
        console.log("No vendor data found");
    }
    const [loading, setLoading] = useState(false)
    const [disable, setDisable] = useState(false);

    // amenities list state start
    const [amenitiesList, setAmenitiesList] = useState([]);
    const [amenitiesSelectedOptions, setAmenitiesSelectedOptions] = useState<any>([]);
    var amenityId = amenitiesSelectedOptions ? amenitiesSelectedOptions.map((option: any) => option.value).join(',') : "";
    // amenities list state end
    // service language list state start
    const [serviceLanguageList, setServiceLanguageList] = useState([]);
    const [serviceLanguageSelectedOptions, setServiceLanguageSelectedOptions] = useState<any>([]);
    var serviceLanguage = serviceLanguageSelectedOptions ? serviceLanguageSelectedOptions.map((option: any) => option.value).join(',') : "";
    // service language list state end

    // set error state
    const [error, setError] = useState([{
        amenityId: '',
        serviceLanguage: '',
    }])

    // remove validation function
    const removeError = (err: any) => {
        var tmp = [...error] as any;
        tmp[0][err] = "";
        setError(tmp);
    }

    // amenityList api call
    const amenityListAPIcall = async () => {

        var param = {
            'categoryId': '1'
        }
        var res = await fetchData("public/amenityList", param)

        if (res.status == "200") {
            var opt: any = []
            res.data.map((val: any) => {
                opt.push({ value: val.amenityId, label: getTranslatedValue(lang, val, '_name') })
            })
            setAmenitiesList(opt)
        }
        else {
            toasterrormsg(res.message)
        }
    }

    // service language list api call
    const serviceLanguageListAPIcall = async () => {

        var param = {
            'categoryId': '1'
        }
        var res = await fetchData("public/serviceLanguageList", param)

        if (res.status == "200") {
            var opt: any = []
            res.data.map((val: any) => {
                opt.push({ value: val.servicelanguageId, label: getTranslatedValue(lang, val, '_name') })
            })
            setServiceLanguageList(opt)
        }
        else {
            toasterrormsg(res.message)
        }
    }
    // validation function
    const validate = () => {

        var isValid = true;
        var errorTmp = [...error];

        if (amenitiesSelectedOptions.length == 0) {
            errorTmp[0].amenityId = t('Property Amenities Is Required');
            isValid = false;
        }
        if (serviceLanguageSelectedOptions.length == 0) {
            errorTmp[0].serviceLanguage = t('Service Language Is Required');
            isValid = false;
        }

        setError(errorTmp);
        return isValid;
    }
    // add hotel api call
    const addHotelFacilitiesApi = async () => {

        if (validate()) {

            setDisable(true)
            setLoading(true);
            let param: any = {
                hotelId: editHotelId,
                serviceLanguage: serviceLanguage,
                amenityId: amenityId
            }

            var res = await fetchData("public/addHotelFacilities", param)
            if (res.status == "200") {
                toastsuccessmsg(t("Facilities Added Successfully!"))
                const state = {
                    hotelId: editHotelId
                }
                setTimeout(() => {
                    navigate("../addhotelfinance/", { state });
                    setDisable(false)
                }, 1500);
            }
            else {
                toasterrormsg(res.message)
                setDisable(false)
            }
        }
    }

    // hotel Details api call
    const hotelDetailsApiCall = async () => {
        var param: any = {
            hotelId: editHotelId,
        }
        var response: any = await fetchData("public/hotelDetailsV2", param)
        if (response.status == "200") {
            setHotelDetails(response.data)
            var data = response.data[0]
            var amenities: any = []
            data.amenityId.map((val: any) => {
                amenities.push({ value: val.amenityId, label: val.en_name })
            })
            setAmenitiesSelectedOptions(amenities)
            var serviceLanguage: any = []
            if (data.serviceLanguageDetail && data.serviceLanguageDetail.length > 0) {
                data.serviceLanguageDetail.map((val: any) => {
                    serviceLanguage.push({ value: val.servicelanguageId, label: getTranslatedValue(lang, val, '_name') })
                })
                setServiceLanguageSelectedOptions(serviceLanguage)
            }
        }
        else {
            toasterrormsg(response.message)
        }
    }

    useEffect(() => {

        amenityListAPIcall();
        serviceLanguageListAPIcall();
        if (editHotelId != "") {
            hotelDetailsApiCall();
        }
    }, [])

  useEffect(() => {
    document.title = 'Insayr | Add Hotel - Facilities';
  }, []);

    return (

        <>
            <ToastContainer />
            <PageTitle breadcrumbs={[]}>{editHotelId != "" ? t('Edit Facilities and Services') : t('Add Facilities and Services')}</PageTitle>
            <AddHotelHeader hotelId={editHotelId} />
            <div className="d-flex flex-column flex-column-fluid">
                {/* <!--begin::Content--> */}
                <div id="kt_app_content" className="app-content flex-column-fluid">
                    {/* <!--begin::Form--> */}
                    <div className="form d-flex flex-column flex-lg-row">
                        {/* <!--begin::Main column--> */}
                        <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
                            {/* <!--begin::Tab content--> */}
                            <div className="tab-content">
                                {/* <!--begin::Tab pane--> */}
                                <div className="tab-pane fade show active" id="kt_ecommerce_add_product_general" role="tab-panel">
                                    <div className="d-flex flex-column">
                                        {/* <!--begin::General options--> */}
                                        <div className="card card-flush py-4">
                                            {/* <!--begin::Card header--> */}
                                            <div className="card-header d-flex">
                                                {/* <!--begin::Card title--> */}
                                                <div className="card-title">
                                                    <h2>{t('Property Facilities and Services')}</h2>
                                                </div>
                                                {/* <!--end::Card title--> */}
                                                <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                                                    {
                                                        hotelDetails.length != 0 ? (
                                                            <>
                                                                {
                                                                    hotelDetails.map((completedSteps: any, index: any) => {
                                                                        var percentage = 0;
                                                                        if (completedSteps['completedSteps']['basicInfo']) {
                                                                            percentage = 10;
                                                                        }
                                                                        if (completedSteps['completedSteps']['location']) {
                                                                            percentage = 20;
                                                                        }
                                                                        if (completedSteps['completedSteps']['propertyDetail']) {
                                                                            percentage = 40;
                                                                        }
                                                                        if (completedSteps['completedSteps']['roomAndSpace']) {
                                                                            percentage = 50;
                                                                        }
                                                                        if (completedSteps['completedSteps']['photos']) {
                                                                            percentage = 60;
                                                                        }
                                                                        if (completedSteps['completedSteps']['facilitiesAndServices']) {
                                                                            percentage = 70;
                                                                        }
                                                                        if (completedSteps['completedSteps']['policies']) {
                                                                            percentage = 90;
                                                                        }
                                                                        if (completedSteps['completedSteps']['financeAndLegal']) {
                                                                            percentage = 100;
                                                                        }
                                                                        return (
                                                                            <React.Fragment key={index}>
                                                                                <div className='d-flex justify-content-between w-100 mt-auto'>
                                                                                    <span className='fw-bold fs-6'>{t('Completion')}</span>
                                                                                    <span className='fw-bolder fs-6'>{percentage}%</span>
                                                                                </div>
                                                                                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                                                                    <div
                                                                                        className='bg-success rounded h-5px'
                                                                                        role='progressbar'
                                                                                        style={{ width: `${percentage}%` }}
                                                                                    ></div>
                                                                                </div>
                                                                            </React.Fragment>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div className='d-flex justify-content-between w-100 mt-auto'>
                                                                    <span className='fw-bold fs-6'>{t('Completion')}</span>
                                                                    <span className='fw-bolder fs-6'>0%</span>
                                                                </div>
                                                                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                                                    <div
                                                                        className='bg-success rounded h-5px'
                                                                        role='progressbar'
                                                                        style={{ width: '0%' }}
                                                                    ></div>
                                                                </div>
                                                            </>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            {/* <!--end::Card header--> */}
                                            {/* <!--begin::Card body--> */}
                                            <div className="card-body pt-10">
                                                {/* <!--begin::Input group--> */}
                                                <div className="row">
                                                    <div className="col-lg-4 my-3">
                                                        {/* <!--begin::Label--> */}
                                                        <label className="required fs-4 form-label">{t('Property Amenities')}</label>
                                                        {/* <!--end::Label--> */}
                                                        {/* <!--begin::Input--> */}
                                                        <Select
                                                            name='amenities[]'
                                                            id='amenitiesListId'
                                                            placeholder={t('Select Amenities')}
                                                            isSearchable={true}
                                                            isMulti
                                                            options={amenitiesList}
                                                            value={amenitiesSelectedOptions}
                                                            onChange={(e: any) => { setAmenitiesSelectedOptions(e); removeError("amenityId"); }}
                                                        />
                                                        {/* <!--end::Input--> */}
                                                        <div className='text-danger fw-bold'>{error[0].amenityId}</div>
                                                    </div>
                                                    <div className="col-lg-4 my-3">
                                                        {/* <!--begin::Label--> */}
                                                        <label className="fs-4 form-label required">{t('Service Language')}</label>
                                                        {/* <!--end::Label--> */}
                                                        {/* <!--begin::Input--> */}
                                                        <Select
                                                            name='serviceLanguage[]'
                                                            id='serviceLanguage'
                                                            placeholder={t('Select Service Language')}
                                                            isSearchable={true}
                                                            isMulti
                                                            options={serviceLanguageList}
                                                            value={serviceLanguageSelectedOptions}
                                                            onChange={(e: any) => { setServiceLanguageSelectedOptions(e); removeError("serviceLanguage"); }}
                                                        />
                                                        {/* <!--end::Input--> */}
                                                        <div className='text-danger fw-bold'>{error[0].serviceLanguage}</div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Input group--> */}
                                            </div>
                                            {/* <!--begin::Card body--> */}
                                        </div>
                                        {/* <!--end::Pricing--> */}
                                    </div>
                                </div>
                                {/* <!--end::Tab pane--> */}
                            </div>
                            {/* <!--end::Tab content--> */}
                            <div className="d-flex justify-content-end">
                                {/* <!--end::Button--> */}
                                <button type="button" disabled={disable} className="btn btn-primary" onClick={addHotelFacilitiesApi}>
                                    <span className="indicator-label">{t('Next')}</span>
                                    {loading && (
                                        <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                                    )}
                                </button>
                                {/* <!--end::Button--> */}
                            </div>
                        </div>
                        {/* <!--end::Main column--> */}
                    </div>
                    {/* <!--end::Form--> */}
                </div>
                {/* <!--end::Content--> */}
            </div>
        </>
    )
}

export { AddHotelFacilities }
